
import Groups from './Groups/Routes';
import Items from './Items/Routes';
import ProductGroup from './ProductGroup/Routes';

export default [...Items, ...Groups, ...ProductGroup];